import React from 'react';
import { SvgIcon } from '../svg-icon';

export const ArrowLeft = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z" />
  </SvgIcon>
);
